import React, {FunctionComponent, ReactElement} from 'react';

interface Props {
    left?: ReactElement;
    right?: ReactElement;
    children: any;
}

const Bar: FunctionComponent<Props> = ({ left, right, children }) => {

    return (
        <div className={'bar'}>
            { left &&
                <div className={'bar__element--left'}>
                    { left }
                </div>
            }

            <div className={'bar__content'}>
                { children }
            </div>

            { right &&
                <div className={'bar__element--left'}>
                    { right }
                </div>
            }
        </div>
    );
};

export default Bar;
